// DialogDemoSubscriptionUpgrade Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Dialog from '../../layout/dialog/dialog.jsx'
import Button from '../../common/button/button.jsx'
import FabButtonManager from '../../../lib/fabbuttonmanager.jsx'
import IntlMessage from '../../common/intl/intl_message.jsx'
import Checkbox from '../../form/checkbox/checkbox.jsx'

class DialogDemoSubscriptionUpgrade extends Component {
  constructor (props) {
    super(props)

    this.state = {
      active: props.active ? props.active : false,
      startEmpty: false,
      contHgt: null
    }
  }

  static get propTypes () {
    return {
      onUpgrade: PropTypes.func,
      onRequestDemo: PropTypes.func,
      active: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      onUpgrade: null,
      onRequestDemo: null,
      active: false
    }
  }

  componentDidMount () {
    window.addEventListener('resize', this.handleResize.bind(this))
    this.handleResize()
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.handleResize)
  }

  handleResize () {
    const minheight = this.getWindowHeight()
    this.setState({ contHgt: { height: minheight } })
  }

  getWindowHeight () {
    const windowHgt = window.innerHeight + 'px'

    return windowHgt
  }

  show () {
    FabButtonManager.setVisible(false)
    this.setState({ active: true })
  }

  hide () {
    FabButtonManager.setVisible(true)
    this.setState({ active: false })
  }

  render () {
    return (
      <Dialog
        className='dialog-demoupgrade'
        active={this.state.active}
        modal={false}
      >
        <div
          className='dialog-demosubscriptionupgrade'
          style={this.state.contHgt}
        >
          <form method='post' action='#'>
            <div className='upgrade-container'>
              <div className='upgrade-header'>
                <img
                  src='/images/common/signup_logo.png'
                  alt='Rodeo'
                  className='inline-image'
                />
                <span className='splitter' />
                <h2 className='title'>
                  <i className='icon icon-register-success' />
                  <IntlMessage ident='common.demo.upgradeTitle' />
                </h2>
              </div>
              <div className='upgrade-content'>
                <div className='typo'>
                  <h2 className='title'>
                    <IntlMessage ident='common.demo.upgradeContent' />
                  </h2>
                </div>
                <Checkbox
                  label='common.demo.labelEmptyAccount'
                  checked={this.state.startEmpty}
                  icon='register'
                  onChange={this._onCheckAccount.bind(this, 'startEmpty')}
                />
                <div className='footer'>
                  <Button
                    title='common.demo.actionUpgrade'
                    icon='register-success'
                    className='upgrade'
                    canHover={false}
                    onClick={this._onClickUpgrade.bind(this)}
                  />
                  <Button
                    title='common.demo.actionRequestDemo'
                    className='upgrade request'
                    canHover={false}
                    onClick={this._onRequestDemo.bind(this)}
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
      </Dialog>
    )
  }

  /* Event handlers */
  _onClickUpgrade (ev) {
    ev.preventDefault()

    if (this.props.onUpgrade) {
      this.props.onUpgrade(this.state.startEmpty)
    }
  }

  _onRequestDemo (ev) {
    ev.preventDefault()

    if (this.props.onRequestDemo) {
      this.props.onRequestDemo()
    }
  }

  _onCheckAccount (name, value) {
    this.setState({ [name]: value })
  }
}

export default DialogDemoSubscriptionUpgrade
